import { createContext, useContext, useState, type ReactNode } from "react";

import {
    contextIsVisible,
    toggleQuestionContext,
    type ContextVisibilityState
} from "@/lib/context-visibility";

type CaptureAnchor = () => Promise<(() => void) | null>;

// Retained for the section scroll helper; there is no global toggle to anchor now.
const registerScrollAnchor = (_capture: CaptureAnchor) => () => {};
const VisibilityContext = createContext({
    visible: (_key: string): boolean => true,
    toggle: (_key: string) => {},
    show: (_key: string) => {},
    registerScrollAnchor
});
export const useContextVisibility = () => useContext(VisibilityContext);

export function ContextVisibilityProvider({ children }: { children: ReactNode; visitId: string }) {
    // The retired floating toggle's saved "hide all" preference must not leave
    // additional context hidden with no control available to reveal it.
    const [state, setState] = useState<ContextVisibilityState>({ showAll: true, overrides: {} });
    return (
        <VisibilityContext.Provider
            value={{
                registerScrollAnchor,
                visible: (id) => contextIsVisible(state, id),
                toggle: (id) => setState((current) => toggleQuestionContext(current, id)),
                show: (id) =>
                    setState((current) => ({
                        ...current,
                        overrides: { ...current.overrides, [id]: true }
                    }))
            }}
        >
            {children}
        </VisibilityContext.Provider>
    );
}
